<template>
  <el-dialog :title="$t('langcfg.txtScanQuality')" :visible.sync="visible" width="50%">
    <table style="font-size: 25px; width: 100%; height: 500px">
      <tbody style="font-size: 25px; width: 100%; height: 500px">
        <tr v-for="item in QS" :key="item.key">
          <td :style="`text-align: right;padding-right:15px;width:${isDE ? 60 : 50}%;`">
            {{ $t(`langcfg.txt${item.key}`) }}:
          </td>
          <td :style="`text-align: left;padding-left:15px;width:${isDE ? 40 : 50}%;`">
            <span :style="`color:${item.color}`">{{
              item.label === "--" ? "--" : $t(`langcfg.${item.label}`)
            }}</span>
          </td>
          <td v-if="isExpertMode" style="text-align: center; min-width: 100px">
            {{ getFixed(item.value) }}
          </td>
        </tr>
      </tbody>
    </table>
    <div slot="footer" class="dialog-footer">
      <el-button class="btn-oprator" type="primary" @click="hideDialog('OK')">{{
        $t("langcfg.txtOK")
      }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { paramNormal } from "../../../shared/filters";
export default {
  name: "QS",
  data() {
    return {
      visible: false,
      isDE: window.settings.language === "de"
    };
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    isDiff: {
      type: Boolean,
      default: false
    },
    qs: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    QS() {
      let qs = [];
      for (let id = 0; id < this.qs.length - 1; id++) {
        if (this.qs[id].included) {
          qs.push(this.qs[id]);
        }
      }

      return qs;
    },
    isExpertMode() {
      return window.settings && window.settings.expertMode;
    }
  },
  updated() {
    this.isDE = window.settings.language === "de";
  },
  watch: {
    isVisible: function (val) {
      this.visible = val;
    },
    visible: function (val) {
      this.initLayout();
      if (!val) {
        this.$emit("update:isVisible", false);
      }
    },
    qs: []
  },
  methods: {
    getFixed(v) {
      return paramNormal(v, { fixed: 0, rpText: "--" });
    },
    initLayout() {},
    hideDialog(state) {
      this.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.qs-label {
  text-align: left;
  min-height: 25px;
  word-wrap: break-word;
}

.btn-oprator {
  border: 1px gray solid;
  height: @header-fs+50px;
  width: 200px;
  font-size: 30px;
}
.btn-oprator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-oprator:active {
  background: @btn-active-color;
}
</style>



// WEBPACK FOOTER //
// src/topography/pages/dialog-forms/QS.vue